module.exports = __webpack_public_path__ + "img/1-5.3d989f67.png";